import EditableCardEntryDepartmentBase from "./EditableCardEntryDepartmentBase";
import {SC_Department} from "../../util/api/enums/SC_Department";

const EditableCardEntryDepartment = ({fancy = false, isEditing, onEdit, baseValue, displayLabel = "Departments", showPCID = false}) => {
    return (
        <EditableCardEntryDepartmentBase
            isEditing={isEditing}
            onEdit={onEdit}
            baseValue={baseValue}
            displayLabel={displayLabel}
            isMultiSelect={true}
            showPCID={showPCID}
            fancy={fancy}
        />
    );
}

export default EditableCardEntryDepartment;
